import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography, Slide, TextField, InputAdornment} from '@material-ui/core';


//Redux
import { forgotPin } from "../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide() {
    const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const handleChange = prop => event => {
    setValues({...values, [prop]: event.target.value});
  }

  const handleSubmit = async () => {
    await  dispatch(forgotPin(values))
    .then(rs => {
      console.log(rs);
      handleClose();
    })
    .catch(err => {
      console.log(err)
    })

  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log(values)

  return (
    <div>
      <Button color="primary" onClick={handleClickOpen}><Typography className="text-center text-info clickable" variant="body1">Forgot PIN?</Typography></Button>   
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"New Pin Request"}</DialogTitle>
        <DialogContent>
        <TextField
                  error={errors && errors.phone}
                  fullWidth
                  helperText={errors && errors.phone}
                  label="Mobile Number"
                  margin="dense"
                  size="small"
                  onChange={handleChange('phone')}
                  value={values.phone}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        +63
                      </InputAdornment>
                    ),
                  }}
                />
             <TextField 
              label="email"
              fullWidth
              size="small"
              value={values.email}
              onChange={handleChange('email')}
              margin="dense"
              type="email"
              variant="standard"
              variant="outlined"
            />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
          Cancel
          </Button>
          <Button onClick={() => handleSubmit()} color="primary">
          Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
